import {memo} from 'react';
import Link from 'next/link';

import styles from '@styles/dropAuction/dropAuction.module.scss';
const WatchAuction = () => {
	return (
        <div className={styles.watchAut}>
			<div className={styles.watchAutTxt}>
				<h2> Still not sure what the heck&apos;s going on? </h2>
				<Link href='drop-auctions/how-it-works' className={styles.seeBtnAction}>
					Read more about how Drops work
				</Link>
			</div>
		</div>
    );
};

export default memo(WatchAuction);
